package com.zq.webproject.ui.about

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.zq.webproject.getPlatform
import org.jetbrains.compose.resources.Font
import androidx.compose.ui.text.font.FontFamily
import webproject.composeapp.generated.resources.Res
import webproject.composeapp.generated.resources.font_song

// 统一字体
private val CaiFont: FontFamily
    @Composable
    get() = FontFamily(Font(Res.font.font_song))

/**
 * 关于页面
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AboutScreen(
    onBackClick: () -> Unit
) {
    Scaffold(
        topBar = {
            TopAppBar(
                title = {
                    Text(
                        text = "关于",
                        fontFamily = CaiFont,
                        fontWeight = FontWeight.Bold
                    )
                },
                navigationIcon = {
                    IconButton(onClick = onBackClick) {
                        Icon(
                            imageVector = Icons.AutoMirrored.Filled.ArrowBack,
                            contentDescription = "返回"
                        )
                    }
                },
                colors = TopAppBarDefaults.topAppBarColors(
                    containerColor = Color(0xFF1E88E5),
                    titleContentColor = Color.White,
                    navigationIconContentColor = Color.White
                )
            )
        }
    ) { paddingValues ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(paddingValues)
                .background(Color(0xFFF5F5F5))
                .verticalScroll(rememberScrollState())
        ) {
            Spacer(modifier = Modifier.height(24.dp))
            
            // 应用Logo和名称
            AppInfoCard()
            
            Spacer(modifier = Modifier.height(16.dp))
            
            // 版本信息
            VersionInfoCard()
            
            Spacer(modifier = Modifier.height(16.dp))

            
            Spacer(modifier = Modifier.height(16.dp))
            
            // 联系方式
            ContactCard()
            
            Spacer(modifier = Modifier.height(32.dp))
        }
    }
}

/**
 * 应用信息卡片
 */
@Composable
fun AppInfoCard() {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp),
        shape = RoundedCornerShape(16.dp),
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(32.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // Logo图标
            Surface(
                modifier = Modifier.size(80.dp),
                shape = RoundedCornerShape(16.dp),
                color = Color(0xFF1E88E5)
            ) {
                Box(
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        imageVector = Icons.Default.Store,
                        contentDescription = "应用Logo",
                        tint = Color.White,
                        modifier = Modifier.size(48.dp)
                    )
                }
            }
            
            Spacer(modifier = Modifier.height(16.dp))
            
            // 应用名称
            Text(
                text = "学库",
                fontSize = 24.sp,
                fontWeight = FontWeight.Bold,
                fontFamily = CaiFont,
                color = Color.Black
            )
            
            Spacer(modifier = Modifier.height(8.dp))
            
            // 应用简介
            Text(
                text = "智能电商平台",
                fontSize = 14.sp,
                color = Color.Gray,
                fontFamily = CaiFont,
                textAlign = TextAlign.Center
            )
        }
    }
}

/**
 * 版本信息卡片
 */
@Composable
fun VersionInfoCard() {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp),
        shape = RoundedCornerShape(12.dp),
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(20.dp)
        ) {
            Text(
                text = "版本信息",
                fontSize = 16.sp,
                fontWeight = FontWeight.Bold,
                fontFamily = CaiFont,
                modifier = Modifier.padding(bottom = 16.dp)
            )
            
            InfoRow(
                icon = Icons.Default.Info,
                label = "应用版本",
                value = "1.0.0"
            )
            
            Divider(
                color = Color(0xFFEEEEEE),
                modifier = Modifier.padding(vertical = 12.dp)
            )
            
            InfoRow(
                icon = Icons.Default.PhoneAndroid,
                label = "运行平台",
                value = getPlatform().name
            )
            
            Divider(
                color = Color(0xFFEEEEEE),
                modifier = Modifier.padding(vertical = 12.dp)
            )
            
            InfoRow(
                icon = Icons.Default.Code,
                label = "构建版本",
                value = "1"
            )
        }
    }
}



/**
 * 联系方式卡片
 */
@Composable
fun ContactCard() {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp),
        shape = RoundedCornerShape(12.dp),
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(20.dp)
        ) {
            Text(
                text = "联系我们",
                fontSize = 16.sp,
                fontWeight = FontWeight.Bold,
                fontFamily = CaiFont,
                modifier = Modifier.padding(bottom = 16.dp)
            )
            
            InfoRow(
                icon = Icons.Default.Email,
                label = "客服邮箱",
                value = "565150953@qq.com"
            )
            
            Divider(
                color = Color(0xFFEEEEEE),
                modifier = Modifier.padding(vertical = 12.dp)
            )
            
            InfoRow(
                icon = Icons.Default.Language,
                label = "官方网站",
                value = "https://shop.aiotzq.com"
            )
            
            Divider(
                color = Color(0xFFEEEEEE),
                modifier = Modifier.padding(vertical = 12.dp)
            )
            
            InfoRow(
                icon = Icons.Default.LocationOn,
                label = "公司地址",
                value = "中国"
            )
        }
    }
}

/**
 * 信息行组件
 */
@Composable
fun InfoRow(
    icon: ImageVector,
    label: String,
    value: String
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            imageVector = icon,
            contentDescription = label,
            tint = Color(0xFF1E88E5),
            modifier = Modifier.size(20.dp)
        )
        
        Spacer(modifier = Modifier.width(12.dp))
        
        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = label,
                fontSize = 13.sp,
                color = Color.Gray,
                fontFamily = CaiFont
            )
            Spacer(modifier = Modifier.height(4.dp))
            Text(
                text = value,
                fontSize = 14.sp,
                color = Color.Black,
                fontFamily = CaiFont,
                fontWeight = FontWeight.Medium
            )
        }
    }
}

/**
 * 技术项组件
 */
@Composable
fun TechItem(name: String, version: String) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(
                color = Color(0xFFF5F5F5),
                shape = RoundedCornerShape(8.dp)
            )
            .padding(12.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = name,
            fontSize = 14.sp,
            color = Color.Black,
            fontFamily = CaiFont
        )
        Text(
            text = "v$version",
            fontSize = 13.sp,
            color = Color(0xFF1E88E5),
            fontFamily = CaiFont,
            fontWeight = FontWeight.Medium
        )
    }
}
